import { render, staticRenderFns } from "./createCodeRecord.vue?vue&type=template&id=70af8f4e&scoped=true&"
import script from "./createCodeRecord.vue?vue&type=script&lang=js&"
export * from "./createCodeRecord.vue?vue&type=script&lang=js&"
import style0 from "./createCodeRecord.vue?vue&type=style&index=0&id=70af8f4e&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70af8f4e",
  null
  
)

export default component.exports